(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function switchFvwTab(btn) {
      var gallery = btn.closest('.product-gallery');
      var idx = parseInt(btn.dataset.target, 10);
      var thumb = gallery.querySelectorAll('.pg-thumb')[idx];
      if (thumb) {
        thumb.click();
      } else {
        gallery.querySelectorAll('.product-gallery__panel').forEach(function (panel) {
          panel.classList.toggle('product-gallery__panel--active', panel.dataset.panel === String(idx));
        });
      }
      gallery.querySelectorAll('.fvw-tab').forEach(function (b) {
        b.classList.toggle('btn--primary', b === btn);
      });
    }
    document.querySelectorAll('.fvw-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchFvwTab(btn);
      });
      btn.addEventListener('mouseenter', function () {
        switchFvwTab(btn);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-custom-order"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var openBtn = document.getElementById('custom-order-btn');
    var closeBtn = document.getElementById('custom-order-popup-close');
    var popup = document.getElementById('custom-order-popup');
    if (!openBtn || !closeBtn || !popup) return;

    openBtn.addEventListener('click', function () {
      popup.style.display = 'flex';
    });
    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
    });
    popup.addEventListener('click', function (e) {
      if (e.target === popup) popup.style.display = 'none';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
